import { createSlice } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
};

const postCommentSlice = createSlice({
  name: "postComment",
  initialState,
  reducers: {
    postCommentStart: (state) => {
      state.status = ReduxStateType.LOADING;
    },
    postCommentSuccess: (state) => {
      state.status = ReduxStateType.SUCCESS;
    },
    postCommentFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetComment: () => {
      return { ...initialState };
    },
  },
});

export const {
  postCommentStart,
  postCommentSuccess,
  postCommentFailed,
  resetComment,
} = postCommentSlice.actions;

export default postCommentSlice.reducer;
